import angular from 'angular';

import EmailIngestTokenModalComponent from './email-ingest-token-modal.cmpt';

export default angular
    .module('application.component.modals.component.email-ingest-token-modal', [])
    .component(EmailIngestTokenModalComponent.selector, EmailIngestTokenModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/email-ingest-token-modal/index.js